module.exports = __webpack_public_path__ + "static/media/likeGreen.1ffef92a.svg";